import { useState, useEffect, useCallback } from "react";
import {
  Chart,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import SideNave from "../common/sidenav";
import TopNav from "../common/topnav";
import Loading from "../loading/loading";
import { useNavigate } from "react-router-dom";
import { viewDashboard } from "../http/api";
import { useAuth } from "../http/authcontex";
import "./dashboard.css";

Chart.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

export default function DashboardComponent() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const authContext = useAuth();

  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(
    localStorage.getItem("sidebarCollapsed") === "true"
  );

  useEffect(() => {
    localStorage.setItem("sidebarCollapsed", isSidebarCollapsed);
  }, [isSidebarCollapsed]);

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  // KPI state
  const [kpi, setKpi] = useState({
    activeEmployees: 0,
    resignedEmployees: 0,
    newJoineesThisMonth: 0,
    contractsExpiringThisMonth: 0,
  });

  // Department-wise chart data
  const [departmentData, setDepartmentData] = useState({
    labels: [],
    datasets: [
      {
        label: "Employees",
        data: [],
        backgroundColor: "#1f77b4",
      },
    ],
  });

  const fetchDashboardData = useCallback(() => {
    setLoading(true);
    viewDashboard()
      .then((response) => {
        if (response.status === 200) {
          const data = response.data;

          setKpi({
            activeEmployees: data.activeEmployees,
            resignedEmployees: data.resignedEmployees,
            newJoineesThisMonth: data.newJoineesThisMonth,
            contractsExpiringThisMonth: data.contractsExpiringThisMonth,
          });

          // prepare department-wise chart
          setDepartmentData({
            labels: data.departmentWiseEmployees.map((item) => item.department),
            datasets: [
              {
                label: "Employees",
                data: data.departmentWiseEmployees.map((item) => item.count),
                backgroundColor: "#1f77b4",
              },
            ],
          });

          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        if (error.response && error.response.status === 401) {
          authContext.logout();
          navigate("/");
        } else {
          console.error("Dashboard fetch failed:", error);
        }
      });
  }, [authContext, navigate]);

  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  return (
    <div className="DashboardComponent">
      {loading && <Loading />}
      <div className={`sb-nav-fixed ${isSidebarCollapsed ? "collapsed" : ""}`}>
        <TopNav toggleSidebar={toggleSidebar} />
        <div id="layoutSidenav">
          <SideNave
            isSidebarCollapsed={isSidebarCollapsed}
            toggleSidebar={toggleSidebar}
          />
          <div id="layoutSidenav_content">
            <main>
              <div className="container-fluid px-4">
                <h4 className="mt-4 mb-4 fw-bold">Employee Dashboard</h4>
                <div className="row g-3 mb-4">
                  <div className="col-md-3">
                    <div className="card text-white bg-success shadow-lg border-0 rounded-3">
                      <div className="card-body text-center">
                        <h6 className="card-title text-uppercase mb-2">
                          Active Employees
                        </h6>
                        <h2 className="fw-bold mb-0">{kpi.activeEmployees}</h2>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="card text-white bg-danger shadow-lg border-0 rounded-3">
                      <div className="card-body text-center">
                        <h6 className="card-title text-uppercase mb-2">
                          Resigned Employees
                        </h6>
                        <h2 className="fw-bold mb-0">
                          {kpi.resignedEmployees}
                        </h2>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="card text-white bg-primary shadow-lg border-0 rounded-3">
                      <div className="card-body text-center">
                        <h6 className="card-title text-uppercase mb-2">
                          Joinees This Month
                        </h6>
                        <h2 className="fw-bold mb-0">
                          {kpi.newJoineesThisMonth}
                        </h2>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="card text-dark bg-warning shadow-lg border-0 rounded-3">
                      <div className="card-body text-center">
                        <h6 className="card-title text-uppercase mb-2">
                          Expiring Contracts
                        </h6>
                        <h2 className="fw-bold mb-0">
                          {kpi.contractsExpiringThisMonth}
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Department-wise Employee Chart */}
                <div className="row">
                  <div className="col-md-12 mb-4">
                    <div className="card chart-card">
                      <h5 className="card-header">Department Wise Employees</h5>
                      <div className="card-body">
                        <Bar data={departmentData} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}
